import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconClone = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" size={size} {...props}>
        <g
            transform="translate(2 3)"
            stroke={color}
            strokeWidth="1.28"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect fill="none" x="4.48" y="4.48" width="8.32" height="8.32" rx="1.28" />
            <StyledPath
                color="none"
                d="M1.92 8.32h-.64A1.28 1.28 0 010 7.04V1.28C0 .573.573 0 1.28 0h5.76c.707 0 1.28.573 1.28 1.28v.64"
            />
        </g>
    </StyledSvg>
);
